declare class Tooltip {
    static errorNode(node: any, message: string, persistent: boolean);
    static successNode(node: any, message: string, persistent: boolean);
    static updateOpenedTooltipText(node: any, message: any);
}

var Utils = window.Utils = (function () {
    function getObjectPropertyKey(
        property,
        propertyNameTranslator: (property: string, level: number) => string,
        level: number
    ) {
        let key = property;
        if (propertyNameTranslator) {
            key = propertyNameTranslator(property, level);
        }

        return key;
    }
    function getObjectByAttributes(
        prefix,
        element: HTMLElement,
        propertyNameTranslator: (property: string, level: number) => string,
        defaults
    ) {
        const result = $.extend(true, {}, defaults || {});
        for (let i = 0; i < element.attributes.length; i++) {
            const attr = element.attributes[i];
            if (attr.name.indexOf(prefix + '-') == 0) {
                const blockName = attr.name.substr((prefix + '-').length);
                const blockSubNames = blockName.split('-');
                let currentObject = result;
                for (var j = 0; j < blockSubNames.length - 1; j++) {
                    var key = getObjectPropertyKey(
                        blockSubNames[j],
                        propertyNameTranslator,
                        j
                    );
                    if (!currentObject[key]) {
                        currentObject[key] = {};
                    }
                    currentObject = currentObject[key];
                }

                var key = getObjectPropertyKey(
                    blockSubNames[j],
                    propertyNameTranslator,
                    j
                );
                let val: any = $(element).attr(attr.name);

                if (val === 'false') val = false;
                if (val === 'true') val = true;

                const arrayRegex = /^array\:(.*?)$/g;
                const arrayMatch = arrayRegex.exec(val);
                if (arrayMatch) {
                    const array = arrayMatch[1];
                    val = eval(array);
                }

                currentObject[key] = val;
            }
        }

        return result;
    }

    function addAttributes(element, attrName, attributes) {
        if (typeof attributes === 'object') {
            for (const key in attributes) {
                const prefix = (attrName + '-' + key).toLowerCase();

                addAttributes(element, prefix, attributes[key]);
            }
        } else {
            $(element).attr(attrName, attributes);
        }
    }

    function getElementFullType(element) {
        let result = element.tagName.toLowerCase();
        if (result === 'input') {
            result += '-' + $(element).attr('type').toLowerCase();
        }
        return result;
    }

    function tryEval(toEval) {
        try {
            return eval('(' + toEval + ')');
        } catch (e) {}
        return toEval;
    }

    /**
     * Runs directly a function from its name with/without arguments.
     *
     * @param functionName {String}
     * @param context {Object || null}
     */
    function runFunctionByName(functionName, context, args): any {
        // If using Node.js, the context will be an empty object
        if (typeof window == 'undefined') {
            context = context || {};
        } else {
            // Use the window (from browser) as context if none providen.
            context = context || window;
        }

        // Retrieve the namespaces of the function you want to execute
        // e.g Namespaces of "MyLib.UI.alerti" would be ["MyLib","UI"]
        const namespaces = functionName.split('.');

        // Retrieve the real name of the function i.e alerti
        const functionToExecute = namespaces.pop();

        // Iterate through every namespace to access the one that has the function
        // you want to execute. For example with the alert fn "MyLib.UI.SomeSub.alert"
        // Loop until context will be equal to SomeSub
        for (let i = 0; i < namespaces.length; i++) {
            context = context[namespaces[i]];
        }

        // If the context really exists (namespaces), return the function or property
        return context[functionToExecute].apply(context, args);
    }

    function runFunction(func: string, element: any, data?: any): void {
        if (func != null) {
            if (func.lastIndexOf(';') !== func.length - 1) {
                const args = [element];
                if (data != null) args.splice(1, 0, data);
                Utils.runFunctionByName(func, null, args);
            } else {
                Function(func).apply(element, data);
            }
        }
    }

    function showTooltipError(obj: any, data: any, persistent = false) {
        if (data)
            Tooltip.errorNode(
                $(obj),
                typeof data === 'string' ? data : data.error,
                persistent
            );
    }

    function showTooltipSuccess(obj: any, data: any, persistent = false) {
        if (data)
            Tooltip.successNode(
                $(obj),
                typeof data === 'string' ? data : data.success,
                persistent
            );
    }

    function svgHtml(fileName, className) {
        fileName = fileName || '';
        className = className || '';
        return (
            '<svg class="icon ' +
            className +
            '"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' +
            (<any>window).globalAppSettings.svg.defaultSprite +
            '#' +
            fileName +
            '"></use></svg>'
        );
    }

    function displayCoefValue(coefValue: number): string {
        // TODO: just for legacy support, DO NOT USE
        const oddsType = window.globalAppSettings.oddsType;
        switch (oddsType) {
            case 'American':
                if (coefValue > 1 && coefValue < 2)
                    return '-' + Math.round(100 / (coefValue - 1)).toFixed(0);
                if (coefValue === 2) return 'Even';
                if (coefValue > 2)
                    return '+' + Math.round(100 * (coefValue - 1)).toFixed(0);
                return '-';
            case 'British':
                const numerator = Math.round(100 * (coefValue - 1));
                const denominator = 100;
                const hcf = gcd(numerator, denominator);
                return (
                    Math.floor(numerator / hcf) +
                    '/' +
                    Math.floor(denominator / hcf)
                );
            case 'HongKong':
                return (coefValue - 1).toFixed(2);
            case 'Indonesian':
                if (coefValue > 1 && coefValue < 2)
                    return '-' + Math.round(1 / (coefValue - 1)).toFixed(2);
                if (coefValue === 2) return 'Even';
                if (coefValue > 2)
                    return '+' + Math.round(coefValue - 1).toFixed(2);
                return '-';
            case 'Malaysian':
                if (coefValue > 1 && coefValue < 2)
                    return '+' + Math.round(1 / (coefValue - 1)).toFixed(2);
                if (coefValue === 2) return 'Even';
                if (coefValue > 2)
                    return '-' + Math.round(coefValue - 1).toFixed(2);
                return '-';
            case 'European':
            default:
                return coefValue.toFixed(2);
        }
    }

    /**
     * Finds the greatest common divisor using binary GCD algorithm.
     * @param a First number
     * @param b Second number
     * @returns GCD of a and b.
     */
    function gcd(a: number, b: number): number {
        /* GCD(0, b) == b; GCD(a, 0) == a,
           GCD(0, 0) == 0 */
        if (a == 0) return b;
        if (b == 0) return a;

        /*Finding K, where K is the
          greatest power of 2
          that divides both a and b. */
        let k: number;
        for (k = 0; ((a | b) & 1) == 0; ++k) {
            a >>= 1;
            b >>= 1;
        }

        /* Dividing a by 2 until a becomes odd */
        while ((a & 1) == 0) a >>= 1;

        /* From here on, 'a' is always odd. */
        do {
            /* If b is even, remove all factor of 2 in b */
            while ((b & 1) == 0) b >>= 1;

            /* Now a and b are both odd.
               Swap if necessary so a <= b,
               then set b = b - a (which is even).*/
            if (a > b) {
                const t = a;
                a = b;
                b = t;
            }

            b = b - a;
        } while (b != 0);

        /* restore common factors of 2 */
        return a << k;
    }

    return {
        getObjectByAttributes,
        addAttributes,
        getElementFullType,
        tryEval,
        runFunctionByName,
        runFunction,
        showTooltipError,
        showTooltipSuccess,
        svgHtml,
        displayCoefValue,
    };
}());
